<template>
  <div class="room-info">
    <div
      class="room-info__item"
      v-for="info in information"
      :key="_uid+info.key"
    >
      <p class="room-info__content">
        <vb-icon class="room-info__icon" :name="info.icon" :color="sass('primary')" :size="14" />
        <span class="room-info__name">

          <template v-if="info.key === 'rates'">
            <template v-for="bed in info.data[0].bed_groups">
              {{ bed.description }}
            </template>
          </template>

          <template v-else-if="info.key === 'area'">
            Superficie di {{ info.data.square_meters }} m<sup>2</sup>
          </template>

          <template v-else-if="info.key === 'occupancy'">
            Per {{ info.data.max_allowed.total }} {{ info.data.max_allowed.total === 1 ? 'persona' : 'persone' }}
          </template>

        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { build_data_items } from '@liveeps/utilities'

export default {
  name: 'room-info',

  components: {
  },

  props: {
    room: Object
  },

  data() {
    return {
    }
  },

  computed: {

    // Struttura dati: key, icon, name e content
    information() {
      const { area, occupancy, rates } = this.room,
            parse_room = { rates: rates, area: area, occupancy: occupancy },
            map = [
              { key: 'rates', icon: 'doublebed' },
              { key: 'area', icon: 'zoom' },
              { key: 'occupancy', icon: 'occupants' },
            ]

      return build_data_items(map, parse_room)
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .room-info {
    $this: &;
    display: none;

    @include media-breakpoint-up(md){
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &__item {
      margin-right: $grid-gutter-width / 2;

      &:last-child {
        margin-right: 0;
      }
    }

    &__content {
      display: flex;
      align-items: center;
      margin-bottom: 0;
    }

    &__name {
      margin-left: 5px;
      font-size: $font-size-sm;
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

</style>